
export enum TransactionOperations {
    NONE = 0,
    CHANGE_DETAILS = 1,
    VIEW_LOGS = 2,
}
